import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import apiCall from 'shared/utils/apiCall';

import * as services from '../services/pingUserAvailabilityTracking';
import createAction from './index';

export const PING_USER_AVAILABILITY_TRACKING = createAsyncAction(createAction('PING_USER_AVAILABILITY_TRACKING'));

export const pingUserAvailabilityTracking = () => dispatch => {
  const apiCallParams = {
    mutation: services.PING_USER_AVAILABILITY,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .catch(err => dispatch(errorAction(PING_USER_AVAILABILITY_TRACKING.failure, err)));
};
